import { Resolution } from './recorder/RecorderVideo';

export const RECORDER_RESOLUTIONS: Record<string | number, Resolution> = {
    720: { width: 1280, height: 720 },
    1080: { width: 1920, height: 1080 },
};

export enum HaltReason {
    USER_NOT_RESPONDING = 'USER_NOT_RESPONDING',
    NO_INTERNET_CONNECTION = 'NO_INTERNET_CONNECTION',
    INVALID_MEETING_ROOM_NUMBER = 'INVALID_MEETING_ROOM_NUMBER',
    INVALID_SDP_FORMAT = 'INVALID_SDP_FORMAT',
    ACCESS_FORBIDDEN = 'ACCESS_FORBIDDEN',
    MEETING_ROOMS_QUOTA_EXCEEDED = 'MEETING_ROOMS_QUOTA_EXCEEDED',
    UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export enum GeneralErrorReason {
    ICE_GATHERING_ERROR = 'ICE_GATHERING_ERROR',
    CONNECTION_ERROR = 'CONNECTION_ERROR',
    UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}
